import { connect } from "react-redux";
import Loader from './Loader';

function mapStateToProps(state) {
	return {
		isLoading: state.ui.isLoading,
		isLoadingWithError: state.ui.isLoadingWithError,
	};
}

export default connect(mapStateToProps)(Loader);



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Loader/index.js